/******************************************************************************************
NAV
*******************************************************************************************/

const navBtn = document.querySelector('.site-header__nav-btn'),
      header = document.querySelector('.site-header'),
      overlay = document.querySelector('.site-header__overlay');

navBtn.addEventListener('click', e => {
  header.classList.toggle('site-header--nav-is-open');
});
overlay.addEventListener('click', e => {
  header.classList.remove('site-header--nav-is-open');
});

/******************************************************************************************
QUANTITY INPUTS
*******************************************************************************************/

const minTickets = 1,
  maxTickets = 10,
  qtyInputs = document.querySelectorAll('.qty-input');

qtyInputs.forEach(qtyInput => {

  const input = qtyInput.querySelector('input'),
    minusBtn = qtyInput.querySelector('.js-qty-minus'),
    plusBtn = qtyInput.querySelector('.js-qty-plus');

  minusBtn.disabled = (input.value <= minTickets) ? true : false;
  plusBtn.disabled = (input.value >= maxTickets) ? true : false;

  minusBtn.addEventListener('click', e => {
    e.preventDefault();
    input.stepDown();
    minusBtn.disabled = (input.value <= minTickets) ? true : false;
    plusBtn.disabled = (input.value >= maxTickets) ? true : false;
  });
  plusBtn.addEventListener('click', e => {
    e.preventDefault();
    input.stepUp();
    minusBtn.disabled = (input.value <= minTickets) ? true : false;
    plusBtn.disabled = (input.value >= maxTickets) ? true : false;
  });
  input.addEventListener('change', e => {
    input.value = Math.min(input.value, maxTickets);
    minusBtn.disabled = (input.value <= minTickets) ? true : false;
    plusBtn.disabled = (input.value >= maxTickets) ? true : false;
  })
  
});

/******************************************************************************************
NICER "REMOVE" FROM CART
*******************************************************************************************/

// Submit form whenever "remove" checkbox is clicked (we actually hide the checkbox when JS is on, only showing the label)

const removeCheckboxes = document.querySelectorAll('.cart__remove-checkbox input');

removeCheckboxes.forEach(removeCheckbox => {
  removeCheckbox.addEventListener('change', e => {
    removeCheckbox.closest('form').submit();
  })
});

/******************************************************************************************
BOOKINGS REPORT
*******************************************************************************************/

const bookingsGigSelect = document.querySelector('.bookings-gig-select'),
      ticketTable = document.querySelector('.ticket-table');
bookingsGigSelect.addEventListener('change', () => {
  ticketTable.style.opacity = '.2';
  window.location.href = '/reports/tickets/' + bookingsGigSelect.value;
});